module.exports = __webpack_public_path__ + "img/pdf.26fb7d51.png";